var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmployes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "256px",
    width: "256px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    transform: "rotate(0)matrix(1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M122.763,306.519V156.766c0-11.732,3.094-22.747,8.488-32.3c-12.26,0-85.918,0-98.238,0v0.006 c-17.906,0.124-32.385,14.674-32.385,32.609v149.752c0,10.118,8.202,18.32,18.32,18.32h23.826l6.646,136.613 c1.36,27.954,24.42,49.92,52.407,49.92c27.391,0,49.962-21.499,51.292-48.858l5.217-107.249 C137.304,348.68,122.763,328.929,122.763,306.519z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 412.182,
    cy: 52.901,
    r: 52.274
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M480.467,124.825l0.002-0.044c-8.09,0-81.852,0-99.539,0c5.284,9.48,8.307,20.384,8.307,31.987V306.52 c0,22.085-14.07,41.323-34.134,48.572l5.205,106.989c1.36,27.954,24.42,49.92,52.407,49.92c27.391,0,49.962-21.499,51.292-48.858 l6.697-137.674h22.346c10.118,0,18.32-8.202,18.32-18.32V157.395C511.373,139.955,497.685,125.714,480.467,124.825z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M325.024,124.196l0.002-0.044h-51.693l10.126,10.126c2.379,2.379,2.379,6.238,0,8.617l-10.678,10.678l8.313,93.003 c0.288,3.217-0.578,6.431-2.445,9.067l-17.674,24.973c-1.143,1.614-2.997,2.574-4.973,2.574c-1.976,0-3.832-0.959-4.973-2.574 l-17.674-24.973c-1.865-2.636-2.732-5.85-2.445-9.067l8.313-93.003l-10.678-10.678c-2.379-2.379-2.379-6.238,0-8.617 l10.126-10.126h-50.213v0.006c-17.906,0.124-32.384,14.673-32.384,32.609v149.752c0,10.118,8.202,18.32,18.32,18.32h23.826 l1.62,33.309l5.025,103.304c1.36,27.954,24.42,49.92,52.407,49.92c27.391,0,49.962-21.499,51.292-48.858l5.077-104.366 l1.62-33.309h22.346c10.118,0,18.32-8.202,18.32-18.32V156.766h0.001C355.929,139.327,342.241,125.086,325.024,124.196z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256.741,0c-28.869,0-52.272,23.403-52.272,52.272c0,28.863,23.41,52.274,52.272,52.274 c28.866,0,52.272-23.414,52.272-52.272C309.013,23.403,285.61,0,256.741,0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 101.294,
    cy: 52.584,
    r: 52.274
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmployes);
export default __webpack_public_path__ + "static/media/icon-employes.9f922ec0f890cedbc5529aef607d7c77.svg";
export { ForwardRef as ReactComponent };